import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { InfoSection } from 'Views/Page/Content/Modal/Layouts/CreateYourPlanReviewStep/Layout/InfoSection/InfoSection';
import { InlineErrorAlert } from 'Components/ComponentLibrary/Atoms/Alerts/InlineAlert/InlineErrorAlert';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => InfoSection,
  }, overrideReadOnly)
  .nameOverride('submitWarningMessage', {
    _component: () => InlineErrorAlert,
  }, overrideReadOnly);
export default metaOverrideSet;
